import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, IconButton, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel, Paper } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';

import {getMatchPlayers, getMatchTeams} from './bdd/genericSondage'
import { v4 as uuidv4 } from 'uuid';
const entryTypes = [
  {value : 'player', label : 'Joueur'}, 
  {value : 'team', label : 'Equipe'}, 
  {value : 'txt', label : 'Texte'}
]

const playerList = (match) => match.homeHolders


const Step2 = ({ match, questions, onSubmit, onBack, survey}) => {
  const [choices, setChoices] = useState([]);

  useEffect(() => {
    if(survey.choices)
      setChoices([...survey.choices])
    else{
      const currentQuestion = questions.find(
        (q) => q.label === survey.question
      );

      if(currentQuestion)
        setChoices([...currentQuestion.choices])
    }
  }, [survey, questions])

  const handleAddChoice = () => {

    let newChoice = choices.length > 0 ? 
                              {...choices[choices.length-1], entries : choices[choices.length-1].entries.map(entry => ({...entry, id: uuidv4()}))} 
                                : 
                              { label: 'Nouveau choix', entries: [{ id: uuidv4(), name: 'Nouvelle entrée', type: 'txt' }] }

    setChoices([...choices, newChoice]);
  };

  const handleRemoveChoice = (index)  => {
    setChoices(choices.filter((_, i) => i !== index));
  };

  const handleAddEntry = (choiceIndex)  => {
    setChoices([
      ...choices.slice(0, choiceIndex),
      {
        ...choices[choiceIndex],
        entries: [
          ...choices[choiceIndex].entries,
          { id: uuidv4(), name: 'Nouvelle entrée', type: choices[choiceIndex].entries[choices[choiceIndex].entries.length-1].type }
        ]
      },
      ...choices.slice(choiceIndex + 1)
    ]);
  };

  const handleRemoveEntry = (choiceIndex, entryIndex)  => {
    setChoices([
      ...choices.slice(0, choiceIndex),
      {
        ...choices[choiceIndex],
        entries: choices[choiceIndex].entries.filter(
          (_, i) => i !== entryIndex
        )
      },
      ...choices.slice(choiceIndex + 1)
    ]);
  };

  const handleChangeLabel = (choiceIndex, event) => {
    const newChoices = [...choices];
    newChoices[choiceIndex] = { ...newChoices[choiceIndex], label: event };
    setChoices(newChoices);
  };

  const handleChangeEntryName = (choiceIndex, entryIndex, event) => {
    const newChoices = [...choices];

    switch(choices[choiceIndex].entries[entryIndex].type){
      case 'txt':
        newChoices[choiceIndex].entries[entryIndex].name = event;
      break
      case 'player' :
        newChoices[choiceIndex].entries[entryIndex].name = getMatchPlayers(match).find(p => p._id === event).lastname;
        newChoices[choiceIndex].entries[entryIndex].id = event;
      break
      case 'team' :
        newChoices[choiceIndex].entries[entryIndex].name = getMatchTeams(match).find(p => p._id === event).name;
        newChoices[choiceIndex].entries[entryIndex].id = event;
      break
      default :
    }

    setChoices(newChoices);
      
  };

  const handleChangeEntryType = (choiceIndex, entryIndex, event) => {
    const newChoices = [...choices];
    newChoices[choiceIndex].entries[entryIndex].type = event;
    newChoices[choiceIndex].entries[entryIndex].id = uuidv4();
    setChoices(newChoices);
  };

  const handleSubmit = (event) => {
    if(isFormReady())
      return
    event.preventDefault();
    onSubmit({choices});
  };

  const handleBack = (event) => {
    event.preventDefault();
    onBack();
  };

  const getInformations = (choice) => {
    if(choice.entries.length === 1){
      return 'L\'internaute choisi sa réponse'

    }else{
      return 'L\'internaute devra choisir sa réponse parmi la liste d\'entrées.'
    }
  }

  const getEntryError = (entry) => {
    switch(entry.type){
      case 'player':
        return !getMatchPlayers(match).find(p => p._id === entry.id)
      case 'team' : 
        return !getMatchTeams(match).find(p => p._id === entry.id)
      default :
        return false
    }
  }

  const isFormReady = () => {
    const isError = choices.some((choice, index) => {
      return !choice.entries || 
              (choice.entries.length > 1 && !choice.label) ||
              choice.entries.some(entry => {
                return (entry.type === 'player' && !getMatchPlayers(match).find(p => p._id === entry.id)) ||
                        (entry.type === 'team' && !getMatchTeams(match).find(p => p._id === entry.id)) ||
                        (entry.type === 'txt' && !entry.name)
              })
    })

    return isError
    

  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box sx={{padding:'1rem'}}>
        <Typography variant="h6" gutterBottom>
          Étape 2 : Ajouter des choix
        </Typography>
        <Typography variant="body1" gutterBottom>
          Question : {survey.question}
        </Typography>
      </Box>
     
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center' }}>
        {choices.map((choice, index) => (
          <Box key={index} sx={{ mb: 2, background : index % 2 === 0 ? '#e5e5e570' : 'white', pb : '20px!important' , pl : '20px!important' , pr : '20px!important', border : '1px solid rgb(200,200,200)', borderRadius : '10px', boxShadow : '1px 1px rgb(150,150,150)' }}>
            <Box sx={{display: 'inline-flex', alignItems: 'center'}}>
            <Typography variant="h6" sx={{marginBottom:'0'}} gutterBottom>Choix {index + 1}</Typography>
                  <IconButton
                    aria-label="delete choice"
                    onClick={() => handleRemoveChoice(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
            </Box>
           
            {choice.entries.length > 1 && <TextField
            id={`Choix ${index + 1}`}
            label={`Label ${index + 1}`}
            variant="standard"
            margin="normal"
            fullWidth
            value={choice.label}
            onChange={(e) => handleChangeLabel(index, e.target.value)}
            helperText={'Veuillez saisir un label.'}
            error={!choice.label}
          />}
            <Box sx={{ position : 'relative', display: "flex", flexDirection: "row", justifyContent : 'space-between' }}>
            <Box sx={{ display: "flex", flexDirection: "column", padding:'1rem' }}>
              {choice.entries.map((entry, subIndex) => (
                <Box
                  key={`${index}-${subIndex}`}
                  sx={{ display: "flex", alignItems: "center", mt: 2 }}
                >

                  {entry.type==='txt' && <TextField
                    label={`Entrée ${subIndex + 1}`}
                    value={entry.name}
                    onChange={(e) =>
                      handleChangeEntryName(index, subIndex, e.target.value)
                    }
                    error={!entry.name}
                  />}

                  {entry.type!=='txt' && <FormControl  sx={{ textAlign : 'left', width : 223 }} error={getEntryError(entry)}>
                    <InputLabel id={`entry-name-${index}-${subIndex}-label`}>
                      {choice.entries.length > 1 ? `Entrée ${subIndex + 1}` : `Choix ${index + 1}`}
                    </InputLabel>
                    <Select
                      labelId={`entry-name-${index}-${subIndex}-label`}
                      id={`entry-name-${index}-${subIndex}`}
                      value={entry.id}
                      label={`Entrée ${subIndex + 1}`}
                      placeholder={`Entrée ${subIndex + 1}`}
                      onChange={(e) =>
                        handleChangeEntryName(index, subIndex, e.target.value)
                      }
                    >
                      {entry.type ==='player' && getMatchPlayers(match).map((player) => (
                        <MenuItem key={player._id} value={player._id}>
                          {player.lastname}
                        </MenuItem>
                      ))}
                      {entry.type ==='team' && getMatchTeams(match).map((team) => (
                        <MenuItem key={team._id} value={team._id}>
                          {team.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>}

                  {match.type!=='actu' && <FormControl sx={{ ml: 2, width : 110 }}>
                    <InputLabel id={`entry-type-${index}-${subIndex}-label`}>
                      Type
                    </InputLabel>
                    <Select
                      labelId={`entry-type-${index}-${subIndex}-label`}
                      id={`entry-type-${index}-${subIndex}`}
                      value={entry.type}
                      label="Type"
                      onChange={(e) =>
                        handleChangeEntryType(index, subIndex, e.target.value)
                      }
                    >
                      {entryTypes.map((entryType) => (
                        <MenuItem key={entryType.value} value={entryType.value}>
                          {entryType.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>}
                  {choice.entries.length > 1 && (
                    <IconButton
                      aria-label="remove entry"
                      onClick={() => handleRemoveEntry(index, subIndex)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  )}
                  {subIndex === choice.entries.length - 1 && (
                    <IconButton
                      aria-label="add entry"
                      onClick={() => handleAddEntry(index)}
                    >
                      <AddIcon />
                    </IconButton>
                  )}
                </Box>
              ))}
            </Box>

            <Paper sx={{p : 2, bottom : 0, position : 'relative', height : 50, background : 'rgb(250,250,250)', display: 'flex', alignItems: 'center', padding:'1rem'}}>
              <InfoIcon sx={{padding: '5px'}} /><Typography sx={{padding: '5px'}} variant='subtitle2'>{getInformations(choice)}</Typography>
            </Paper>
            </Box>
          </Box>
        ))}
        <Button variant="contained" onClick={handleAddChoice}>
          Ajouter un choix
        </Button>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Button variant="contained" onClick={handleBack}>
          Retour
        </Button>
        <Button variant="contained" onClick={handleSubmit} sx={{ ml: 2 }} disabled={!choices.length}>
          Suivant
        </Button>
      </Box>
    </Box>
  );

}

export default Step2